import { Box, Flex, Text } from "@chakra-ui/react";
import PropTypes from "prop-types";
import React from "react";

// Wrapper layout with split background
function AuthIllustration({ children }) {
  return (
    <Flex
      minH="100vh"
      width="100%"
      position="relative"
      overflow="hidden"
      flexDirection="column"
    >
      {/* Split background - dark on left, white on right (full width dark on mobile) */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width={{ base: "100%", md: "50%" }}
        height="100vh"
        bg="#151c24"
        zIndex="0"
      />
      <Box
        position="absolute"
        top="0"
        right="0"
        width={{ base: "0%", md: "50%" }}
        height="100vh"
        bg="white"
        zIndex="0"
        display={{ base: "none", md: "block" }}
      />
      
      {/* Content container */}
      <Flex
        width="100%"
        flex="1"
        align="center"
        justify="center"
        position="relative"
        zIndex="1"
      >
        {children}
      </Flex>

      {/* Copyright text - positioned at bottom */}
      <Text
        py="15px"
        px="25px"
        fontSize="xs"
        color="rgba(255, 255, 255, 0.4)"
        letterSpacing="0.5px"
        zIndex="1"
        textAlign={{ base: "center", md: "left" }}
      >
        2025 Trinika Energies Private Limited - All Rights Reserved
      </Text>
    </Flex>
  );
}

AuthIllustration.propTypes = {
  children: PropTypes.node,
};

export default AuthIllustration;
